import React from "react";
import { useTranslation } from "react-i18next";
import { getUserHandle } from "senf-shared";
import Avatar from "../../core/avatar/Avatar";
import Dropdown from "../../core/dropdown/Dropdown";
import { useModals } from "../../molecules/modalStack/ModalProvider";

const ProfileHeader = ({
  profilePageUser,
  accountOwner,
  handleUploadImage,
  handle,
  handleDeleteAccount,
}) => {
  const { t } = useTranslation();
  const { openModal } = useModals();
  return (
    <div className="mb-5 mr-2 flex flex-row items-center justify-between gap-3  pt-5 ">
      <label htmlFor="profileTemplateImageUploader">
        <Avatar
          alt={getUserHandle(
            profilePageUser?.userData?.isAnonymous,
            profilePageUser?.userData?.userId,
            profilePageUser?.userData?.handle,
          )}
          size="sm"
          src={profilePageUser?.userData?.photoURL}
          // loading={!profilePageUser?.userData?.handle}
        />
      </label>
      {accountOwner && (
        <input
          type="file"
          onChange={(e) => handleUploadImage(e)}
          style={{ display: "none" }}
          id="profileTemplateImageUploader"
        />
      )}

      <h3 className="heading-lg mr-auto">
        {getUserHandle(
          profilePageUser?.userData?.isAnonymous,
          profilePageUser?.userData?.userId,
          profilePageUser?.userData?.handle,
        )}
      </h3>

      {accountOwner && (
        <Dropdown
          width="max"
          size="md"
          trailingIcon="more"
          variant="shapeless"
          items={[
            {
              text: t("util:edit", { val: t("global:profile") }),
              leadingIcon: "edit",
              onClick: handle.setAuthEditOpen,
            },
            (!profilePageUser?.userData?.isAnonymous ||
              import.meta.env.VITE_APP_MODE !== "production") && {
              text: t("auth:logout"),
              leadingIcon: "logout",
              onClick: handle.logout,
            },
            accountOwner && {
              // because we need to use firebaseAdmin SDK // @todo: Elevated users cant delete other accounts
              text: t("util:delete", { val: t("global:profile") }),
              leadingIcon: "trash",
              onClick: () =>
                openModal(null, {
                  id: "deleteAccountModal",
                  style: {
                    padding: 20,
                  },
                  title: t("util:delete", { val: t("global:profile") }),
                  cancelText: t("global:cancel"),
                  submitText: t("util:delete", { val: t("global:profile") }),
                  critical: true,
                  onSubmit: () =>
                    openModal(null, {
                      id: "deleteAccountConfirmModal",
                      style: {
                        padding: 20,
                      },
                      title: t("deleteProfileConfirm"),
                      cancelText: t("global:cancel"),
                      submitText: t("global:delete"),
                      critical: true,
                      onSubmit: handleDeleteAccount,
                    }),
                }),
            },
          ]}
        />
      )}
    </div>
  );
};

export default ProfileHeader;
